// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memories-page {
  min-height: 100vh;
  position: relative;
  z-index: 2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 上半部分 - 透明区域 */
.memories-top-section {
  min-height: 40vh;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px 40px;
  position: relative;
}

.memories-top-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, 
    rgba(255, 182, 193, 0.6) 0%, 
    rgba(255, 192, 203, 0.5) 20%,
    rgba(255, 218, 224, 0.4) 50%,
    rgba(255, 240, 245, 0.3) 80%, 
    rgba(255, 255, 255, 0.2) 100%);
  z-index: 1;
}

.memories-top-section > * {
  position: relative;
  z-index: 2;
}

/* 波浪线分割 */
.memories-wave-divider {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  z-index: 3;
  background: transparent;
  margin-top: -50px;
}

.memories-wave-divider svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
}

/* 下半部分 - 从下方粉色到中间白色渐变 */
.memories-bottom-section {
  min-height: 60vh;
  background: linear-gradient(to top, 
    rgba(255, 182, 193, 0.9) 0%, 
    rgba(255, 192, 203, 0.8) 20%, 
    rgba(255, 205, 215, 0.7) 45%, 
    rgba(255, 228, 235, 0.5) 75%, 
    rgba(255, 240, 245, 0.4) 100%
  );
  padding: 40px 20px;
  position: relative;
}

.memories-container {
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
}

.memories-header {
  text-align: center;
  margin-bottom: 50px;
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.memories-title {
  font-size: 3.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);
}

.title-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
  animation: heartbeat 2s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.memories-subtitle {
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.98);
  margin-bottom: 30px;
  font-weight: 500;
  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8);
  letter-spacing: 0.5px;
}

.memories-timeline {
  position: relative;
  padding: 20px 0;
}

.memories-timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #ff69b4, #ff1493, #dc143c);
  transform: translateX(-50%);
}

.memory-item {
  display: flex;
  margin-bottom: 40px;
  cursor: pointer;
  position: relative;
}

.memory-item:nth-child(even) {
  flex-direction: row-reverse;
}

.memory-item:nth-child(even) .memory-card {
  margin-left: 0;
  margin-right: 30px;
}

.memory-item:nth-child(odd) .memory-card {
  margin-left: 30px;
  margin-right: 0;
}

.memory-date {
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  color: white;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
  z-index: 10;
}

.memory-card {
  flex: 1 1;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
  transition: all 0.3s ease;
  position: relative;
}

.memory-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);
  background: rgba(255, 255, 255, 0.2);
}

.memory-mood {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 15px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

.memory-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: white;
  margin-bottom: 10px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.memory-location {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.memory-preview {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin-bottom: 15px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.memory-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.memory-tag {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.add-memory-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 100;
}

.floating-btn {
  background: linear-gradient(135deg, rgba(255, 182, 193, 0.95), rgba(255, 192, 203, 0.9)) !important;
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  color: white !important;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.4), 
              0 4px 15px rgba(255, 182, 193, 0.3);
  transition: all 0.3s ease;
  font-size: 20px;
  position: relative;
  overflow: hidden;
  /* 重置浏览器默认样式 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
}

.floating-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s ease;
}

.floating-btn:hover::before {
  left: 100%;
}

.floating-btn span {
  font-size: 8px;
  margin-top: 2px;
  font-weight: 600;
  color: white !important;
}

.floating-btn:hover {
  transform: scale(1.1) translateY(-2px);
  background: linear-gradient(135deg, rgba(255, 105, 180, 0.95), rgba(255, 20, 147, 0.9)) !important;
  border-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.5), 
              0 6px 20px rgba(255, 20, 147, 0.3);
  color: white !important;
}

.floating-btn:hover span {
  color: white !important;
}

/* 模态框样式 */
.memory-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.memory-detail {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border-radius: 25px;
  padding: 40px;
  max-width: 600px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 15px 40px rgba(255, 105, 180, 0.3);
  position: relative;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.detail-mood {
  font-size: 3rem;
  animation: float 3s ease-in-out infinite;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.detail-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.detail-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.detail-date,
.detail-location {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.detail-description {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 1.1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.detail-tag {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* 添加回忆表单样式 */
.memory-form-container {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);
  margin-top: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.form-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 25px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.form-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

.memory-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  flex-direction: column;
}

.form-row-inline {
  display: flex;
  gap: 15px;
}

.form-row-inline .form-row {
  flex: 1 1;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: #ff69b4;
  z-index: 2;
  font-size: 0.9rem;
}

.textarea-icon {
  top: 15px;
  align-self: flex-start;
}

.form-input, .form-textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 15px 15px 15px 45px;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input::placeholder, .form-textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.form-input:focus, .form-textarea:focus {
  outline: none;
  border-color: #ff69b4;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 0 0 2px rgba(255, 105, 180, 0.3);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.5;
}

.form-tags-input {
  padding: 15px 15px 15px 45px;
}

.submit-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(15px);
  border: 2px solid rgba(255, 105, 180, 0.6) !important;
  color: #ff69b4 !important;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 6px 20px rgba(255, 182, 193, 0.3),
              0 2px 10px rgba(255, 255, 255, 0.2);
  align-self: center;
  min-width: 150px;
  position: relative;
  overflow: hidden;
  /* 重置浏览器默认样式 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
}

.submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 192, 203, 0.2), transparent);
  transition: left 0.6s ease;
}

.submit-btn:hover:not(:disabled)::before {
  left: 100%;
}

.submit-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 105, 180, 0.8);
  color: #ff1493;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 182, 193, 0.4),
              0 4px 15px rgba(255, 255, 255, 0.3);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.submit-btn.submitting {
  background: linear-gradient(45deg, #ccc, #999);
}

.submit-icon {
  font-size: 0.9rem;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.5) !important;
  color: rgba(255, 105, 180, 0.8) !important;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  align-self: center;
  min-width: 150px;
  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
  /* 重置浏览器默认样式 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
}

.cancel-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s ease;
}

.cancel-btn:hover::before {
  left: 100%;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.85);
  border-color: rgba(255, 105, 180, 0.6);
  color: #ff69b4;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.4);
}

.form-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 10px;
}

/* 加载状态 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #ff69b4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin: 0;
}

/* 空状态 */
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .memories-timeline::before {
    left: 30px;
  }
  
  .memory-item {
    flex-direction: column !important;
  }
  
  .memory-item:nth-child(even) .memory-card,
  .memory-item:nth-child(odd) .memory-card {
    margin-left: 50px;
    margin-right: 0;
  }
  
  .memory-date {
    left: 30px;
    transform: translateX(-50%);
  }
  
  .memories-title {
    font-size: 2rem;
  }
  
  .floating-btn {
    width: 50px;
    height: 50px;
    font-size: 16px;
  }
  
  .memory-detail {
    padding: 30px 20px;
  }
}

@media (max-width: 480px) {
  .memories-page {
    padding: 10px;
  }
  
  .back-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 20px;
    display: inline-flex;
  }
  
  .memories-title {
    font-size: 1.8rem;
  }
  
  .memory-detail {
    padding: 20px 15px;
  }
  
  .detail-title {
    font-size: 1.5rem;
  }
  
  .detail-meta {
    flex-direction: column;
    gap: 10px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/MemoriesPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;kCAKgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB;;;;;;GAMC;EACD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,uDAAuD;EACvD,4CAA4C;AAC9C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uEAAuE;EACvE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,oDAAoD;EACpD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mGAAmG;EACnG,2BAA2B;EAC3B,qDAAqD;EACrD,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;iDAC+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,kGAAkG;EAClG,iDAAiD;EACjD;gDAC8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT;iDAC+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;EACd,2BAA2B;EAC3B;iDAC+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;EAC3B,qDAAqD;EACrD,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;AACX;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;EACT,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".memories-page {\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n  background-image: url('../assets/back.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* 上半部分 - 透明区域 */\n.memories-top-section {\n  min-height: 40vh;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px 40px;\n  position: relative;\n}\n\n.memories-top-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, \n    rgba(255, 182, 193, 0.6) 0%, \n    rgba(255, 192, 203, 0.5) 20%,\n    rgba(255, 218, 224, 0.4) 50%,\n    rgba(255, 240, 245, 0.3) 80%, \n    rgba(255, 255, 255, 0.2) 100%);\n  z-index: 1;\n}\n\n.memories-top-section > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* 波浪线分割 */\n.memories-wave-divider {\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n  position: relative;\n  z-index: 3;\n  background: transparent;\n  margin-top: -50px;\n}\n\n.memories-wave-divider svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 180px;\n}\n\n/* 下半部分 - 从下方粉色到中间白色渐变 */\n.memories-bottom-section {\n  min-height: 60vh;\n  background: linear-gradient(to top, \n    rgba(255, 182, 193, 0.9) 0%, \n    rgba(255, 192, 203, 0.8) 20%, \n    rgba(255, 205, 215, 0.7) 45%, \n    rgba(255, 228, 235, 0.5) 75%, \n    rgba(255, 240, 245, 0.4) 100%\n  );\n  padding: 40px 20px;\n  position: relative;\n}\n\n.memories-container {\n  max-width: 1000px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.memories-header {\n  text-align: center;\n  margin-bottom: 50px;\n  width: 100%;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.memories-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);\n}\n\n.title-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n  animation: heartbeat 2s ease-in-out infinite;\n}\n\n@keyframes heartbeat {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.memories-subtitle {\n  font-size: 1.3rem;\n  color: rgba(255, 255, 255, 0.98);\n  margin-bottom: 30px;\n  font-weight: 500;\n  text-shadow: 0 3px 8px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.8);\n  letter-spacing: 0.5px;\n}\n\n.memories-timeline {\n  position: relative;\n  padding: 20px 0;\n}\n\n.memories-timeline::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(to bottom, #ff69b4, #ff1493, #dc143c);\n  transform: translateX(-50%);\n}\n\n.memory-item {\n  display: flex;\n  margin-bottom: 40px;\n  cursor: pointer;\n  position: relative;\n}\n\n.memory-item:nth-child(even) {\n  flex-direction: row-reverse;\n}\n\n.memory-item:nth-child(even) .memory-card {\n  margin-left: 0;\n  margin-right: 30px;\n}\n\n.memory-item:nth-child(odd) .memory-card {\n  margin-left: 30px;\n  margin-right: 0;\n}\n\n.memory-date {\n  position: absolute;\n  left: 50%;\n  top: 20px;\n  transform: translateX(-50%);\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  color: white;\n  padding: 8px 15px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n  z-index: 10;\n}\n\n.memory-card {\n  flex: 1;\n  max-width: 400px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.memory-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.memory-mood {\n  font-size: 2rem;\n  text-align: center;\n  margin-bottom: 15px;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n}\n\n.memory-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 10px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.memory-location {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  margin-bottom: 15px;\n}\n\n.memory-preview {\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.5;\n  margin-bottom: 15px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.memory-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.memory-tag {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.add-memory-btn {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  z-index: 100;\n}\n\n.floating-btn {\n  background: linear-gradient(135deg, rgba(255, 182, 193, 0.95), rgba(255, 192, 203, 0.9)) !important;\n  backdrop-filter: blur(20px);\n  border: 2px solid rgba(255, 255, 255, 0.8) !important;\n  color: white !important;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.4), \n              0 4px 15px rgba(255, 182, 193, 0.3);\n  transition: all 0.3s ease;\n  font-size: 20px;\n  position: relative;\n  overflow: hidden;\n  /* 重置浏览器默认样式 */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: none;\n}\n\n.floating-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.6s ease;\n}\n\n.floating-btn:hover::before {\n  left: 100%;\n}\n\n.floating-btn span {\n  font-size: 8px;\n  margin-top: 2px;\n  font-weight: 600;\n  color: white !important;\n}\n\n.floating-btn:hover {\n  transform: scale(1.1) translateY(-2px);\n  background: linear-gradient(135deg, rgba(255, 105, 180, 0.95), rgba(255, 20, 147, 0.9)) !important;\n  border-color: rgba(255, 255, 255, 0.9) !important;\n  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.5), \n              0 6px 20px rgba(255, 20, 147, 0.3);\n  color: white !important;\n}\n\n.floating-btn:hover span {\n  color: white !important;\n}\n\n/* 模态框样式 */\n.memory-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.memory-detail {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(15px);\n  border-radius: 25px;\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 15px 40px rgba(255, 105, 180, 0.3);\n  position: relative;\n}\n\n.detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.detail-mood {\n  font-size: 3rem;\n  animation: float 3s ease-in-out infinite;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.detail-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 20px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.detail-meta {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.detail-date,\n.detail-location {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n}\n\n.detail-description {\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.6;\n  margin-bottom: 20px;\n  font-size: 1.1rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.detail-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.detail-tag {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 15px;\n  font-size: 0.9rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n/* 添加回忆表单样式 */\n.memory-form-container {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(15px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);\n  margin-top: 40px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.form-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 25px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.form-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n.memory-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-row-inline {\n  display: flex;\n  gap: 15px;\n}\n\n.form-row-inline .form-row {\n  flex: 1;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 15px;\n  color: #ff69b4;\n  z-index: 2;\n  font-size: 0.9rem;\n}\n\n.textarea-icon {\n  top: 15px;\n  align-self: flex-start;\n}\n\n.form-input, .form-textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 12px;\n  padding: 15px 15px 15px 45px;\n  color: white;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-input::placeholder, .form-textarea::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.form-input:focus, .form-textarea:focus {\n  outline: none;\n  border-color: #ff69b4;\n  background: rgba(255, 255, 255, 0.25);\n  box-shadow: 0 0 0 2px rgba(255, 105, 180, 0.3);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 100px;\n  line-height: 1.5;\n}\n\n.form-tags-input {\n  padding: 15px 15px 15px 45px;\n}\n\n.submit-btn {\n  background: rgba(255, 255, 255, 0.9) !important;\n  backdrop-filter: blur(15px);\n  border: 2px solid rgba(255, 105, 180, 0.6) !important;\n  color: #ff69b4 !important;\n  padding: 15px 30px;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 6px 20px rgba(255, 182, 193, 0.3),\n              0 2px 10px rgba(255, 255, 255, 0.2);\n  align-self: center;\n  min-width: 150px;\n  position: relative;\n  overflow: hidden;\n  /* 重置浏览器默认样式 */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: none;\n}\n\n.submit-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 192, 203, 0.2), transparent);\n  transition: left 0.6s ease;\n}\n\n.submit-btn:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 105, 180, 0.8);\n  color: #ff1493;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(255, 182, 193, 0.4),\n              0 4px 15px rgba(255, 255, 255, 0.3);\n}\n\n.submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.submit-btn.submitting {\n  background: linear-gradient(45deg, #ccc, #999);\n}\n\n.submit-icon {\n  font-size: 0.9rem;\n}\n\n.cancel-btn {\n  background: rgba(255, 255, 255, 0.7) !important;\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.5) !important;\n  color: rgba(255, 105, 180, 0.8) !important;\n  padding: 15px 30px;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  align-self: center;\n  min-width: 150px;\n  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);\n  position: relative;\n  overflow: hidden;\n  /* 重置浏览器默认样式 */\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: none;\n}\n\n.cancel-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.6s ease;\n}\n\n.cancel-btn:hover::before {\n  left: 100%;\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.85);\n  border-color: rgba(255, 105, 180, 0.6);\n  color: #ff69b4;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(255, 255, 255, 0.4);\n}\n\n.form-buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n/* 加载状态 */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid #ff69b4;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* 空状态 */\n.empty-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.empty-text {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1.1rem;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .memories-timeline::before {\n    left: 30px;\n  }\n  \n  .memory-item {\n    flex-direction: column !important;\n  }\n  \n  .memory-item:nth-child(even) .memory-card,\n  .memory-item:nth-child(odd) .memory-card {\n    margin-left: 50px;\n    margin-right: 0;\n  }\n  \n  .memory-date {\n    left: 30px;\n    transform: translateX(-50%);\n  }\n  \n  .memories-title {\n    font-size: 2rem;\n  }\n  \n  .floating-btn {\n    width: 50px;\n    height: 50px;\n    font-size: 16px;\n  }\n  \n  .memory-detail {\n    padding: 30px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .memories-page {\n    padding: 10px;\n  }\n  \n  .back-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 20px;\n    display: inline-flex;\n  }\n  \n  .memories-title {\n    font-size: 1.8rem;\n  }\n  \n  .memory-detail {\n    padding: 20px 15px;\n  }\n  \n  .detail-title {\n    font-size: 1.5rem;\n  }\n  \n  .detail-meta {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
